import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import StyledDiv from 'components/styled/StyledDiv';
import { quoteLinkApiClient } from 'config/quoteLinkApi';
import ServerRenderContent from './ServerRenderContent';

export default function Message({
  className = '',
  updateInView,
  welcomeText,
  aboutMeText,
}) {
  const [brandProfile, setBrandProfile] = useState('');
  const [ref, inView] = useInView({ threshold: 0.1 });

  useEffect(() => {
    updateInView(inView);
  }, [inView, updateInView]);

  useEffect(() => {
    if (!aboutMeText) {
      const getBrandProfileContent = async () => {
        const { data } = await quoteLinkApiClient.get(
          '/api/v1.10/content/query?query=type==textBlock$ANDlocation==brandProfile',
        );
        setBrandProfile(data[0]?.htmlContent);
      };
      getBrandProfileContent();
    }
  }, [aboutMeText]);

  const customStyles = `
    h1 {
      font-size: 1.5rem;
    }
    h1, h2, h3, h4, h5 {
      font-weight: 700;
    }
    p {
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
  `;

  if (brandProfile !== '' && brandProfile != null) {
    return (
      <div className={className} id="introduction" ref={ref}>
        <StyledDiv customStyles={customStyles}>
          <ServerRenderContent html={brandProfile} />
        </StyledDiv>
      </div>
    );
  }

  if (welcomeText !== '' && welcomeText != null) {
    return (
      <div className={className} id="introduction" ref={ref}>
        <StyledDiv customStyles={customStyles}>
          <p>{welcomeText}</p>
        </StyledDiv>
      </div>
    );
  }

  if (aboutMeText !== '' && aboutMeText != null) {
    return (
      <div className={className} id="introduction" ref={ref}>
        <StyledDiv customStyles={customStyles}>
          <p>{aboutMeText}</p>
        </StyledDiv>
      </div>
    );
  }

  return <div className={className} id="introduction" ref={ref} />;
}
